import { useContext, useEffect, useState } from 'react'
import {
    RemoteConfigContext,
    BannerConfigItem,
} from '../../../src/firebase/FirebaseRemoteConfig.provider'
import { useLocation } from 'react-router-dom'
import { areBannerDatesValid, isBannerForCurrentPage } from './helpers'

export function useBanner(): BannerConfigItem[] {
    const { bannerConfig } = useContext(RemoteConfigContext)
    const { pathname } = useLocation()
    const [visibleBanners, setVisibleBanners] = useState<BannerConfigItem[]>([])

    useEffect(() => {
        const tempVisibleBanners = bannerConfig
            .filter((config) => {
                return (
                    areBannerDatesValid(
                        config.startsAtUTC,
                        config.expiresAtUTC,
                    ) && isBannerForCurrentPage(config.pageUrl, pathname)
                )
            })
            .sort((a, b) => {
                // if url is empty, it should be on top of the list
                if (a.pageUrl === '' && b.pageUrl !== '') return -1
                if (a.pageUrl !== '' && b.pageUrl === '') return 1
                // otherwise, sort by start date
                return (
                    new Date(a.startsAtUTC).getTime() -
                    new Date(b.startsAtUTC).getTime()
                )
            })

        setVisibleBanners(tempVisibleBanners)
    }, [bannerConfig, pathname])

    return visibleBanners
}
